import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { Usersnap_ModuleContextService } from './Usersnap.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class Usersnap_widgetform_ComponentContextService {
  private readonly moduleContext: Usersnap_ModuleContextService;

  constructor(moduleContext: Usersnap_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'widgetform',
      type: ComponentType.form
    }
  }
}